export default "__VITE_ASSET__DslucImx__"